import type {ActionSpec, ActionStruct} from '@cohort/shared/apps/app';
import {z} from 'zod';

export const GetContactListsInputSchema = z.object({
  sort: z.enum(['asc', 'desc']).optional(),
});
export type GetContactListsInput = z.infer<typeof GetContactListsInputSchema>;

export const GetContactListsOutputSchema = z.object({
  lists: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
      totalBlacklisted: z.number().optional(),
      totalSubscribers: z.number().optional(),
      uniqueSubscribers: z.number().optional(),
      folderId: z.number().optional(),
      dynamicList: z.boolean().optional(),
    })
  ),
  count: z.number(),
});
export type GetContactListsOutput = z.infer<typeof GetContactListsOutputSchema>;

export type GetContactListsActionStruct = ActionStruct<
  'get-contact-lists',
  GetContactListsInput,
  GetContactListsOutput
>;
export const GetContactListsActionSpec: ActionSpec<GetContactListsActionStruct> = {
  id: 'get-contact-lists',
  inputSchema: GetContactListsInputSchema,
  outputSchema: GetContactListsOutputSchema,
};
